import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'

function FlexibleCancellationCharterFlightFees() {
  return <BodyText variant="medium" as="span">
    <b>Date changes</b>
    <br />
    One change permitted. Subject to availability and surcharges (peak period or property-specific).
    <br />
    <br />
    <b>Cancellations</b>
    <br />
    Cancellations made during this period will incur the following fees:
    <ul>
      <li>
        Economy: $995 per person
      </li>
      <li>
        Business: $2,995 per person
      </li>
    </ul>
    The remaining balance, after deduction of the applicable cancellation fees, will be refunded to your original payment or credit.
  </BodyText>
}

export default FlexibleCancellationCharterFlightFees
